import { render, staticRenderFns } from "./ResourceListDetailsSection.vue?vue&type=template&id=b8f9ad7c"
import script from "./ResourceListDetailsSection.vue?vue&type=script&lang=js"
export * from "./ResourceListDetailsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports